export default {
	about_the: 'A propos des',
	document: 'Document',
	company_agency: 'Magasin enregistré dans votre profil:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explorez tout notre univers de cours, vidéos, articles et dossiers.',
	project_name: 'Educa Tigre',
	welcome_to: 'Bienvenue à',
	challenge_of_the_day: "Défi des Bêtes \\ Défi Supplémentaire",
	profession: 'Quel est votre domaine d\'activité aujourd\'hui?',
	comercial: 'Commercial',
	construction_professional: 'Professionnel de la construction',
	login_azure: "Accès d'Entreprise",
}
